<template>
  <VContent>
    <template slot="right">
      <span>مسؤولي المصارف</span>
    </template>
    <template slot="left">
      <b-button variant="info" size="md" class="text-light" v-b-modal.admin-modal>اضافة</b-button>
    </template>
    <template slot="content">
      <b-input-group class="mb-3">
        <b-form-input v-model="searchName" placeholder="بحث حسب الاسم" @keydown.enter="getAll"
          class="ml-3"></b-form-input>
        <b-form-input v-model="searchPhone" type="number" placeholder="بحث حسب رقم الهاتف"
          @keydown.enter="getAll"></b-form-input>
        <b-input-group-append>
          <b-button class="mx-3" @click="getAll" variant="primary">بحث</b-button>
          <b-button @click="clearFilters" variant="danger" v-b-tooltip.hover title="الغاء البحث">
            <b-icon icon="x-circle"></b-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <b-table :items="items" :fields="fields" :tbody-transition-props="transProps" tbody-tr-class="text-muted"
        responsive table-class="table-font h-100">
        <template #cell(id)="data">
          {{ (page - 1) * 10 + data.index + 1 }}
        </template>
        <template v-slot:cell(name)="{ item }">
          <img :src="ImageURL(item)" width="35" height="35" class="bg-info rounded-circle mx-3" />
          {{ item.name }}
        </template>
        <template v-slot:cell(email)="{ item }">
          <div class="p-2 rounded-pill green">{{ item.email }}</div>
        </template>
        <template v-slot:cell(bank)="{ item }">
          <div class="p-2 rounded-pill orange">{{ item.bank.name }}</div>
        </template>
        <template v-slot:cell(created_at)="{ item }">{{
          new Date(item.created_at).toISOString().slice(0, 10)
        }}</template>
        <template v-slot:cell(actions)="{ item }">
          <b-dropdown size="lg" variant="link" no-caret>
            <template #button-content>
              <b-icon icon="three-dots" animation="cylon"></b-icon>
            </template>
            <b-dropdown-item @click="getByID(item.id, true)">
              <b-icon icon="file-earmark-medical" scale="0.5" class="ml-2"></b-icon>
              عرض</b-dropdown-item>
            <b-dropdown-item @click="getByID(item.id, false)">
              <b-icon icon="pencil-square" scale="0.5" class="ml-2"></b-icon>
              تعديل</b-dropdown-item>
            <b-dropdown-item @click="remove(item.id)">
              <b-icon icon="archive" scale="0.5" class="ml-2"></b-icon>
              حذف</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </template>
    <template slot="modals">
      <AdminModal :readonly="readonly" @close="readonly = false"></AdminModal>
    </template>
    <template slot="bottom">
      <b-pagination v-model="page" :current-page="meta.current_page" :per-page="meta.per_page"
        :total-rows="meta.last_page * meta.per_page"></b-pagination>
    </template>
  </VContent>
</template>

<script>
import AdminModal from "./components/adminModal";
import {
  successAlert,
  errorAlert,
  showAlertWithConfirm,
  ImageURL,
} from "@/utils/helper";

export default {
  components: { AdminModal },
  data() {
    return {
      page: 1,
      searchPhone: '',
      searchName: '',
      readonly: false,
      transProps: {
        name: "flip-list",
      },
      fields: [
        {
          key: "id",
          label: "أ",
          sortable: true,
        },
        {
          key: "name",
          label: "الأسم",
          sortable: true,
        },
        {
          key: "phone",
          label: "رقم الهاتف",
          sortable: true,
        },
        {
          key: "email",
          label: "البريد الألكتروني",
          sortable: true,
        },
        {
          key: "bank",
          label: "أسم المصرف",
          sortable: true,
        },
        {
          key: "created_at",
          label: "تاريخ  الأنضمام",
          sortable: true,
        },
        {
          key: "actions",
          label: "العمليات",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    items() {
      return this.$store.state.admin.admins.list;
    },
    meta() {
      return this.$store.state.admin.admins.meta;
    },
  },
  watch: {
    page() {
      this.getAll();
    },
  },
  mounted() {
    this.getAll();
  },
  methods: {
    getAll() {
      this.$store.dispatch("admin/admins/get", { page: this.page, phone: this.searchPhone, name: this.searchName });
    },
    clearFilters() {
      this.searchName = '';
      this.searchPhone = '';
      this.getAll();
    },
    getByID(id, status) {
      this.$store
        .dispatch("admin/admins/show", id)
        .then(() => {
          this.readonly = status;
          this.$bvModal.show("admin-modal");
        })
        .catch(() => errorAlert());
    },
    remove(id) {
      showAlertWithConfirm().then((response) => {
        if (response.isConfirmed) {
          this.$store
            .dispatch("admin/admins/delete", id)
            .then(() => {
              successAlert();
              this.$store.commit("admin/admins/DELETE_ADMIN", id);
            })
            .catch((error) =>
              errorAlert(
                error.response ? error.response.data.message : "فشل الحذف"
              )
            );
        }
      });
    },
    ImageURL(item) {
      return item.image ? item.image : ImageURL("user.jpg");
    },
  },
};
</script>

<style lang="scss"></style>
